(() => {
  function initBundlePickmix(productId) {
    const data = window.bundlePickmixData?.[productId];
    const root = document.getElementById(`bundle-pickmix-${productId}`);
    if (!data || !root) return;

    const state = {
      required: data.required,
      selections: {},
      get total() {
        return Object.values(this.selections).reduce((a, b) => a + b, 0);
      },
      get remaining() {
        return this.required - this.total;
      },
      get fulfilled() {
        return this.total === this.required;
      },
    };

    const atcBtn = root.querySelector('.bundle-pickmix__atc');
    const totalEl = root.querySelector('.bundle-pickmix__total');
    const remainingEl = root.querySelector('.bundle-pickmix__remaining');
    const progressBar = root.querySelector('.bundle-pickmix__progress-bar');

    function updateCounter() {
      totalEl.textContent = state.total;
      remainingEl.textContent = state.remaining;
      progressBar.style.width = `${Math.min((state.total / state.required) * 100, 100)}%`;

      if (state.fulfilled) {
        atcBtn.disabled = false;
        atcBtn.removeAttribute('aria-disabled');
        atcBtn.textContent = data.addToCartLabel;
      } else {
        atcBtn.disabled = true;
        atcBtn.setAttribute('aria-disabled', 'true');
        atcBtn.textContent = data.hintText;
      }

      // Disable all inc buttons when fulfilled
      root.querySelectorAll('[data-action="inc"]').forEach((btn) => {
        btn.disabled = state.remaining <= 0;
      });
    }

    // Initialise selections from all rendered quantity-selector elements
    // Each variant has two quantity-selectors (mobile + desktop); group by variant-id
    const selectorGroups = {};
    root.querySelectorAll('quantity-selector[data-variant-id]').forEach((qs) => {
      const variantId = qs.getAttribute('data-variant-id');
      if (!selectorGroups[variantId]) selectorGroups[variantId] = [];
      selectorGroups[variantId].push(qs);
      state.selections[variantId] = 0;
    });

    function syncSelectors(variantId) {
      const qty = state.selections[variantId] || 0;
      selectorGroups[variantId].forEach((qs) => {
        qs.querySelector('.quantity-selector__input').value = qty;
        qs.querySelector('[data-action="dec"]').disabled = qty <= 0;
      });
    }

    // Bind events for each variant group
    Object.keys(selectorGroups).forEach((variantId) => {
      selectorGroups[variantId].forEach((qs) => {
        qs.querySelector('[data-action="dec"]').addEventListener('click', () => {
          if (state.selections[variantId] <= 0) return;
          state.selections[variantId]-=1;
          syncSelectors(variantId);
          updateCounter();
        });

        qs.querySelector('[data-action="inc"]').addEventListener('click', () => {
          if (state.remaining <= 0) return;
          state.selections[variantId]+=1;
          syncSelectors(variantId);
          updateCounter();
        });

        // Use blur instead of change to avoid double-trigger from Web Component
        // (quantity-selector WC updates input.value before our click handler runs,
        //  causing change to fire with stale state — blur only fires on user focus-out)
        qs.querySelector('.quantity-selector__input').addEventListener('blur', (e) => {
          const raw = parseInt(e.target.value, 10);
          const current = state.selections[variantId] || 0;
          
          if (isNaN(raw) || raw === current) return;
          const clamped = Math.max(0, Math.min(raw, current + state.remaining));
          state.selections[variantId] = clamped;
          syncSelectors(variantId);
          updateCounter();
        });
      });
    });

    updateCounter();

    function showErrorBanner(messages) {
      // Remove existing banner before showing a new one to prevent stacking
      root.querySelector('.bundle-pickmix__error')?.remove();
      const banner = document.createElement('div');
      banner.className = 'bundle-pickmix__error banner banner--error';
      banner.setAttribute('role', 'alert');
      banner.setAttribute('aria-live', 'assertive');
      banner.innerHTML = messages.map((m) => `<p>${m}</p>`).join('');
      atcBtn.closest('td').prepend(banner);
      setTimeout(() => banner.remove(), 5000);
    }

    // ATC handler
    atcBtn.addEventListener('click', async () => {
      if (!state.fulfilled) return;
      atcBtn.disabled = true;
      atcBtn.setAttribute('aria-busy', 'true');

      try {
        // Tag every line item with bundle properties (underscore-prefixed = hidden from customer)
        const bundleId = `pickmix-${data.productId}-${Date.now()}`;
        const items = Object.entries(state.selections)
          .filter(([, qty]) => qty > 0)
          .map(([variantId, qty]) => ({
            id: parseInt(variantId),
            quantity: qty,
            properties: {
              _bundle_id: bundleId,
              _bundle_type: 'pickmix',
              _bundle_required: state.required,
            },
          }));

        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        });

        if (!res.ok) {
          // 422 = inventory insufficient — Shopify returns a descriptive message
          const errData = await res.json().catch(() => null);
          const msg = errData?.description || errData?.message || '加入購物車失敗，請稍後再試';
          showErrorBanner([msg]);
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          return;
        }

        const cartType = window.themeVariables?.settings?.cartType;

        if (cartType === 'message') {
          const banner = document.createRange().createContextualFragment(`
            <div class="banner banner--success" role="status" aria-live="polite">
              ${window.themeVariables?.strings?.addedToCart ?? '已加入購物車'}
            </div>
          `).firstElementChild;
          atcBtn.closest('td').prepend(banner);
          setTimeout(() => banner.remove(), 2500);
        }

        document.dispatchEvent(new CustomEvent('cart:refresh'));
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          cartDrawer.show();
        } else if (cartType !== 'message') {
          window.location.href = '/cart';
        }
      } catch (err) {
        console.error('[bundle-pickmix] add to cart error:', err);
      } finally {
        atcBtn.disabled = !state.fulfilled;
        atcBtn.removeAttribute('aria-busy');
        if (state.fulfilled) atcBtn.removeAttribute('aria-disabled');
      }
    });
  }

  document.querySelectorAll('[id^="bundle-pickmix-"]').forEach((el) => {
    const match = el.id.match(/^bundle-pickmix-(\d+)$/);
    if (match) initBundlePickmix(match[1]);
  });
})();
